import {OFFER_DURATION_TYPES, OfferDuration, OfferDurationType} from '@core/shared/models/offer/offer-duration';

/**
 * Type d'une durée, pour le groupement journée/séjour du filtre de recherche.
 *
 * @param duration Durée renvoyée par l'API
 */
export const getOfferDurationType = (duration: OfferDuration): OfferDurationType => {

    if(OFFER_DURATION_TYPES.includes(duration.type)){

        return duration.type;
    }

    return (duration.value > 1) ? 'stay' : 'day';
};
